'use client';

import { Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import type { NavLinkChild, NavServiceCardConfig } from '@/config/navigation.config';
import { Link } from '@/i18n/navigation';
import colors from '@/styles/themes/colors';

import styles from './NavItemCard.module.scss';

interface NavItemCardProps {
  child: NavLinkChild;
  config: NavServiceCardConfig;
}

const NavItemCard = ({ child, config }: NavItemCardProps) => {
  const t = useTranslations('common');

  return (
    <Link href={child.href as '/'} className={styles.container} role="menuitem">
      <Image src={config.image} width={82} height={82} alt="" />
      <Stack gap={0}>
        <Typography variant="subtitle1" fontWeight={500} color={colors.white}>
          {t(child.labelKey)}
        </Typography>
        <Typography variant="body1" color={colors.graytone200}>
          {/* @ts-expect-error - Dynamic translation key from config */}
          {t(config.descriptionKey)}
        </Typography>
      </Stack>
    </Link>
  );
};

export default NavItemCard;
